// extracted by mini-css-extract-plugin
export default {"price":"Qma-z","onSale":"Rma-z","msrpLabelPrice":"Sma-z","msrpLabel":"Tma-z","originalPrice":"Uma-z"};